<template>
  <v-card class="slide-editor fill-height">
    <v-toolbar flat>
      <div v-if="active">
        <h2 class="header">
          {{ active.name }}
        </h2>
        <b class="subtitle">{{ active.externalId }}</b>
      </div>
      <v-spacer />
      <v-btn icon @click="$emit('close')">
        <v-icon>{{ icons.close }}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider />
    <div class="fill-height">
      <i-rack class="slide-fg">
        <i-section>
          <slide-annotation class="slide-canvas" />
        </i-section>
        <i-section :width="500" class="slide-fg">
          <v-container class="pa-1" column>
            <!--
            <task-list-tile
              v-for="task in list"
              :key="task._id"
              :task="task"
              @mouseover.native="taskActive(task)"
            ></task-list-tile>

            <div
              :key="task._id"
              @mouseover.native="taskActive(task)"
              v-for="task in list"
            >
              <v-textarea
                :label="task.data.author"
                :value="task.data.text"
                auto-grow
                class="focus"
                outline
                readonly
                rows="2"
              ></v-textarea>
            </div>
            -->
            <div v-if="!ordered_items || !ordered_items.length" class="pa-5">
              <span class="title">No task available</span>
              <br /><br />
              <span class="subheading">
                Please add a task by double clicking or click-and-drag on the preview.
              </span>
            </div>
            <todo-list in-editor :enable-button="false" />
            <div class="tasks-bottom-padding" />
          </v-container>
        </i-section>
      </i-rack>
    </div>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import SlideAnnotation from '@/components/slides/annotation';
import TaskListTile from '@/components/task-components/subcomponents/task-list-tile';
import { SET_TASK_ACTIVE } from '@/config/constants';
import TaskItem from '@/components/task-components/task-item';
import icons from '../../mixins/icons';
import TodoListVue from '../todos/TodoList.vue';

export default {
  components: {
    SlideAnnotation,
    todoList: TodoListVue
  },
  mixins: [icons],
  data() {
    return {
      open: true
    };
  },
  mounted() {},
  computed: {
    ...mapState('user', {
      email: state => state.me.email
    }),
    ...mapState('slides', {
      active: state => state.active
    }),
    ...mapState('tasks', {
      list: state => state.items
    }),
    ordered_items() {
      return _.orderBy(this.list, 'createdAt', 'desc');
    }
  },
  methods: {
    taskActive(task) {
      this.$store.commit(SET_TASK_ACTIVE, task);
    }
  }
};
</script>

<style lang="scss">
@mixin vertical-align($position: relative) {
  position: $position;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.slide-editor.v-card {
  overflow: hidden;
  border-radius: 0px;

  & subtitle {
    color: #ccc;
  }
}

.slide-bg {
  background: #454545;
}

.slide-fg {
  background: #fff;
}

.slide-editor .slide-canvas {
  background: #fff;
  /*
    @include vertical-align();
    */
}

.task-list-tile {
  margin-top: 10px;
  margin-bottom: 20px;

  &.task-list-tile-comment {
    margin-left: 55px;
    cursor: initial;
  }

  a.v-list__tile {
    height: auto;

    & .v-list__tile__sub-title {
      white-space: initial;
    }
    & .v-list__tile__avatar {
      align-self: flex-start;
    }
  }

  .task-list-tile-title-append {
    color: #555;
    font-size: 15px;
  }

  .task-list-tile-text-container {
    background: #f3f3f3;
    padding: 10px;
    border-radius: 5px;
    width: 100%;
  }
  .task-list-tile-comment .task-list-tile-text-container {
    background: #ececec;
  }

  button.task-list-tile-check.v-btn {
    top: 0px !important;
    right: 1px !important;
  }

  .task-list-tile-text {
    resize: none;
    outline: none;
    border: none;
    font-family: inherit;
    font-size: 14px;
    width: 100%;
  }

  .task-list-tile-buttons {
    text-align: right;
    width: 100%;
    margin-top: 5px;

    & button {
      margin-left: 5px;
    }
    & button:first-child {
      margin-left: 0px;
    }
  }
}

.tasks-bottom-padding {
  padding-bottom: 100px;
}
</style>
